const en=  {
  	language: {
  	  	'name': '中文'
  	},
  	navbar: {
  	  	home: 'Home',
  	  	introduction: 'Instructions',
  	  	cooperation: 'Cooperation',
  	  	contact: 'Contact Us',
  	  	about: 'About Us',
  	  	info1:'A self-guided travel products trading platform',
  	  	info2:'CN Travel Group',

  	},
  	log:{
  		name:' A self-guided travel products trading platform',
  		system:'Hotels and Suppliers Management System',
  		enterprise:'Enterprise user login',
  		user:'Company number',
  		oper:'Operator number',
  		pwd:'Password',
  		captcha:'Verification Code',
  		login:'Log In',
  		remacc:'Remember account',
  		reg:'New Register',
  		fogpwd:'Forget Password',

  		slogan1:'No reservation is difficult, Because of Dingfangyi.com',
  		slogan2:'You can find whatever you want here.',

  		 
  	},
  	home:{
      title:'GLOBAL HOTEL RESERVATION RESOURCES',
  		text:'Vast Number of G.T.D Hotels Daily in Mainland China, Hong Kong, Macau and Oversea Hot Sale!',
  		text1:'Hong Kong, Macau and Oversea Hot Sale!',
  		text2:'220,000 Hong Kong &Mainland China Hotels for Booking!',
  		text3:'300,000+ Oversea Hotels for Booking! ',
  		text4:'150,000+ Hotels for Instant Booking!',

	  title1:'REAL TIME BOOKING AND CONFIRMATION',
		titletext1:'Combine Product, Booking and Reservation,',
		titletext2:'Solution, Internal Finance Management together,',
		titletext3:'Payment  multi-function just in one.',

	  title2:'EFFICIENT DATA EXCHANGE &DOCKING',
		titletext4:'Dingfangyi.com, which provides standardized API data',
		titletext5:'interface, real-time access to rate, inventory, order place',
		titletext6:'and transaction close can be done just in seconds. The',
		titletext7:'interface provides massive products. E-Travel Ecology',
		titletext8:'carried out by seamless docking, result in manpower',
		titletex9:' saving efficiency improvement.',
		
	  title3:'TRUSTWORTHY CREDIT SUPPORT',
		titletext10:"Your business partner, exclusive interest-free credit",
		titletext11:'settlement, CN Travel Group strong financial reserve' ,
		titletext12:'balance will protect your business, only for you to use',
		titletext13:'better, order more smoothly.'
  	},
  	footer:{
  		know:'How to know us',
  		about:'About Us',
  		contact:'Contact Us',
  		suggestions:'Suggestions',
  		join:'Join Us',

  		info1:'ustomer notice',
  		info2:'Booking instructions',
  		info3:'Agreement download',
  		info4:'Textbook download',

  		email:'Contact Email',
  		email1:'Domestic products：chinahotel-1@cnbooking.net',
  		email2:'HK products：hkhotel-3@cnbooking.net',
  		email3:'Global Products：globalhotel-12@cnbooking.net',
  		email4:'Macau Products：macauhotel-1@cnbooking.net',

  		wechat:'WeChat',


  	},
    //按钮
    btn:{
      ok:'Comfirm',
      cancel:'Cancel' 
    },
    index:{
      key:'Hotel/City/Landmark/Key Word',
      search:'Search',
      rooms:'Rooms',
      guest:"Guests",
      star:'Star rating',
      price:'Price per night',

      mo:'Monday',
      tu:'Tuesday',
      we:'Wednesday',
      th:'Thursday',
      fr:'Friday',
      sa:'Saturday',
      su:'Sunday',

      adult:'Adult',
      child:'Child',
      adults:'Adults',//复数
      children:'Children',//复数

      howold:"How old are the children you're traveling with?",
      yearold:'year old',
      yearsold:'years old',//复数

      starnull:'Unrated',
      star2:'2 stars',
      star3:'3 stars',
      star4:'4 stars',
      star5:'5 stars',





      


    }


















}
export default en




// WEBPACK FOOTER //
// ./src/common/lang/en.js